var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ecoRating !== null
    ? _c(
        "div",
        [
          _c("ob1-separateur", { staticClass: "my-2 mb-xl-3" }),
          _vm._v(" "),
          _c("div", { attrs: { id: "anchor-eco-rating" } }),
          _vm._v(" "),
          _c("div", { staticClass: "d-lg-none" }, [
            _c("div", { staticClass: "text-mw" }, [
              _c("h2", {
                domProps: { innerHTML: _vm._s(_vm.ecoRating.title) },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column" },
                [
                  _c("img", {
                    staticClass: "img-fluid mw-100",
                    attrs: {
                      src: _vm.ecoRating.imageUrl,
                      alt: _vm.ecoRating.alt,
                    },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.ecoRating.text) },
                  }),
                  _vm._v(" "),
                  _c("ob1-liens", {
                    attrs: {
                      href: _vm.ecoRating.linkUrl,
                      text: _vm.ecoRating.linkWording,
                      target: _vm.ecoRating.target,
                      "with-arrow": true,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-none d-lg-block" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("h2", {
                    domProps: { innerHTML: _vm._s(_vm.ecoRating.title) },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.ecoRating.text) },
                  }),
                  _vm._v(" "),
                  _c("ob1-liens", {
                    attrs: {
                      href: _vm.ecoRating.linkUrl,
                      text: _vm.ecoRating.linkWording,
                      target: _vm.ecoRating.target,
                      "with-arrow": true,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-6" }, [
                _c("img", {
                  staticClass: "pt-1 img-fluid mw-100",
                  attrs: {
                    src: _vm.ecoRating.imageUrl,
                    alt: _vm.ecoRating.alt,
                  },
                }),
              ]),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }